import React, { useEffect, useState } from "react";
import "./fullscreenspinner.scss";

export default function FullScreenSpinner({ txt }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const to = setTimeout(() => {
      setShow(true);
    }, 500);

    return () => clearTimeout(to);
  }, []);

  return (
    <div
      className={`fs-spinner-container-bg  ${
        show ? "fs-spinner-container-bg-show" : "fs-spinner-container-bg-hide"
      }`}
    >
      <div className="lds-ripple">
        <div />
        <div />
      </div>
      {txt && <div className="fs-info-text">{txt}</div>}
    </div>
  );
}
